import { render, staticRenderFns } from "./AddOutboundOrder.vue?vue&type=template&id=53195c23&"
import script from "./AddOutboundOrder.vue?vue&type=script&lang=js&"
export * from "./AddOutboundOrder.vue?vue&type=script&lang=js&"
import style0 from "./AddOutboundOrder.vue?vue&type=style&index=0&lang=css&"
import style1 from "./AddOutboundOrder.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports